module.exports = __webpack_public_path__ + "img/3_163.837573e8.png";